import React from 'react';
import { deliveryItems } from '../../data/content';
import { CtaButton } from '../CtaButton';
export function Delivery() {
  return <section className="w-full bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-140" data-mp="21ropv79i9328">
      <div className="mx-auto w-full max-w-3xl" data-id="element-141" data-mp="26s2zuuuo2n2w">
        <div className="text-center" data-id="element-142" data-mp="26q9qv8wkzqrq">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.24em] text-blood" data-id="element-143" data-mp="2brz48v7a0giz">
            Delivery
          </p>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-144" data-mp="1e504gblaesgv">
            Get immediate access as soon as your purchase is complete
          </h2>
          <p className="mx-auto mt-4 max-w-md text-[15px] leading-relaxed text-white/65 sm:text-base" data-id="element-145" data-mp="1o0tosh58zq97">
            No shipping. No waiting. No complicated setup.
          </p>
        </div>

        <div className="mt-9 rounded-2xl bg-graphite/70 p-5 ring-1 ring-white/10 sm:p-7" data-id="element-146" data-mp="vdz5hnk62wxb">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-white/70" data-id="element-147" data-mp="10bilot0fdjrw">
            You’ll receive immediate access to:
          </p>
          <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-148" data-mp="wkcvq1ipfnbx">
            {deliveryItems.map(item => <li key={item.text} className="flex items-center gap-3 rounded-xl bg-ink/60 px-4 py-3 ring-1 ring-white/[0.07]" data-id="element-149" data-mp="rodzxsv1r31h">
                <span aria-hidden="true" className="text-lg leading-none" data-id="element-150" data-mp="ithg86dpa7zd">
                  {item.emoji}
                </span>
                <span className="text-[14px] font-semibold leading-snug text-white" data-id="element-151" data-mp="8vjrlhrxi968">
                  {item.text}
                </span>
              </li>)}
          </ul>
          <p className="mt-5 text-center text-[13px] font-medium text-white/60" data-id="element-152" data-mp="3yjnvdijxiia">
            PDF format for computer, tablet or smartphone.
          </p>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-153" data-mp="1y96uvk32dep6">
          <CtaButton label="I want immediate access" variant="light" data-id="element-154" data-mp="1u8wkzwc5i451" />
        </div>
      </div>
    </section>;
}